import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useGetPMSStatus } from "hooks/useGetPMSStatus";

const AddRoom = (params) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    // To fix Chrome autocomplete
    const [autoCompleteDodge, setAutoCompleteDodged] = useState(false);
    const [textPwd, setTextPwd] = useState(false);
    const [currentSecondValue, setCurrentSecondValue] = useState("code")
    //
    const [passVisible, setPassVisible] = useState(false);
    const togglePassVisibility = () => {
        setPassVisible(!passVisible);
    };

    const { register, unregister, handleSubmit, watch, errors, setError, triggerValidation } = useForm();

    const { pmsStatus: hasPMS } = useGetPMSStatus();

    const ROOM_NOT_FOUND_ERROR = "room not found";
    const INVALID_PASSWORD_ERROR = "invalid password";
    const PMS_NOT_CONFIGURED_ERROR = "PMS not configured for this project";

    const INVALID_SURNAME_ERROR = "invalid surname";
    const INVALID_CODE_ERROR = "invalid code";

    const submitForm = (data, e) => {
        setLoading(true);
        params.onSuccess({
            ...data, onError: (error) => {
                if (error?.includes(ROOM_NOT_FOUND_ERROR)) {
                    setError("room", {
                        type: "notFound",
                        message: t(`error.${ROOM_NOT_FOUND_ERROR}`)
                    });
                }
                if (error?.includes(INVALID_PASSWORD_ERROR) || error?.includes(PMS_NOT_CONFIGURED_ERROR)) {
                    setError(currentSecondValue, {
                        type: "invalid",
                        message: t(`error.${hasPMS ? INVALID_SURNAME_ERROR : INVALID_CODE_ERROR}`)
                    });
                }
                setLoading(false);

            }
        }, e);
    };

    useEffect(() => {
        if (hasPMS) {
            unregister("code")
            setCurrentSecondValue("surname")
        } else {
            unregister("surname")
            setCurrentSecondValue("code")
        }
    }, [hasPMS])

    const roomError = errors?.room?.message || errors?.room?.types?.message;
    const secondValueError = errors?.[currentSecondValue]?.message || errors?.[currentSecondValue]?.types?.message;

    return (
        <>
            <form onSubmit={handleSubmit(submitForm)} className={"px-5" + (loading ? " opacity-50" : "")}>
                <div className="my-3">
                    <div className={"float-left text-sm pl-1 pb-1 " + (!watch("room") && "invisible")}>{t("room")}</div>
                    <input
                        ref={register({
                            required: t("required input"),
                        })}
                        type="number"
                        name="room"
                        disabled={loading}
                        autoComplete="off"
                        placeholder={t("room")}
                        onChange={() => triggerValidation("room")}
                        onBlur={() => triggerValidation("room")}
                        onFocus={() => setAutoCompleteDodged(true)}
                        className={roomError ? "error" : ""}
                    />
                    {roomError && <div className="text-error float-right text-sm">{roomError}</div>}
                </div>

                <div className="mt-3 mb-5">
                    <div className={"float-left text-sm pl-17 pb-1 " + (!watch(currentSecondValue) && "invisible")}>
                        {t(currentSecondValue)}
                    </div>
                    <div className="relative">
                        <input
                            ref={register({
                                required: t("required input"),
                            })}
                            type={hasPMS || passVisible || !autoCompleteDodge || textPwd ? "text" : "password"}
                            name={currentSecondValue}
                            disabled={loading}
                            autoComplete="off"
                            placeholder={t(currentSecondValue)}
                            onChange={() => triggerValidation(currentSecondValue)}
                            onBlur={() => {
                                triggerValidation(currentSecondValue);
                                setTextPwd(false);
                            }}
                            onFocus={() => {
                                setAutoCompleteDodged(true);
                                setTextPwd(false);
                            }}
                            className={secondValueError ? "error" : ""}
                        />

                        {!hasPMS &&
                            <i
                                className={
                                    "absolute right-0 m-3 text-neutral-contrast-50 text-xl cursor-pointer icon icon-eye-" +
                                    (passVisible ? "on" : "off")
                                }
                                onClick={() => togglePassVisibility()}
                            ></i>
                        }
                        {secondValueError && <div className="text-error float-right text-sm">{secondValueError}</div>}
                    </div>

                    <div className="flex justify-between mt-10">
                        <button type="submit" disabled={loading} className="flex-1 ml-1 btn btn-accent text-lg">
                            {t("add room")}
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddRoom;
